import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious } from
"../components/ui/carousel";

const HeroSection = () => {
  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 opacity-10">
        <div className="pistachio-decor"></div>
      </div>
      <div className="absolute bottom-20 right-10 opacity-10">
        <div className="pistachio-decor"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-center lg:text-left space-y-6 lg:space-y-8">
            {/* Main Logo */}
            <div className="flex justify-center lg:justify-start">
              <img
                src="/logo.jpg"
                alt="Taste T Pistachio Logo"
                className="w-56 h-56 lg:w-72 lg:h-72 rounded-full object-cover shadow-2xl"
              />
            </div>
            
            <div className="inline-block">
              <span className="inline-block px-4 py-2 bg-gold bg-opacity-20 rounded-full text-olive font-semibold text-sm tracking-wide border border-gold">
                ALL NATURAL • ORGANIC • HOMEMADE
              </span>
            </div>
            
            <h1 className="hero-title text-5xl lg:text-7xl font-bold text-olive leading-tight">
              Flavorful
              <span className="block text-gold">Pistachio</span>
              Delights
            </h1>
            
            <p className="text-lg lg:text-xl text-olive-dark max-w-xl mx-auto lg:mx-0">
              Handcrafted with love in Clermont, FL. Experience the magic of authentic homemade pistachio treats, 
              from decadent cakes to irresistible cookies.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button onClick={scrollToProducts} className="cta-button-primary">
                View Our Menu
              </button>
              <button onClick={scrollToContact} className="cta-button-secondary">
                Order Custom Treats
              </button>
            </div>
          </div>

          {/* Hero Image Carousel */}
          <div className="relative">
            <Carousel className="w-full">
              <CarouselContent>
                <CarouselItem>
                  <div className="hero-image-container">
                    <img
                      src="/cake1.png"
                      alt="Pistachio Cake with Slice"
                      className="hero-image" />

                  </div>
                </CarouselItem>
                <CarouselItem>
                  <div className="hero-image-container">
                    <img
                      src="/cake2.png"
                      alt="Pistachio Cake Top View"
                      className="hero-image" />

                  </div>
                </CarouselItem>
                <CarouselItem>
                  <div className="hero-image-container">
                    <img
                      src="/cake3.png"
                      alt="Pistachio Cake Full View"
                      className="hero-image" />

                  </div>
                </CarouselItem>
              </CarouselContent>
              <CarouselPrevious className="left-2" />
              <CarouselNext className="right-2" />
            </Carousel>
            <div className="hero-badge">
              <span className="text-2xl font-bold text-olive">100%</span>
              <span className="text-sm text-olive-dark">Homemade</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-olive" size={32} />
      </div>
    </section>);

};

export default HeroSection;